import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import { Button, FormattedPrice } from "@jti/ui";
import { PriceTiersContext } from "../../providers/PriceTiersContext";
import styles from "./AddProductButton.module.scss";
const AddToCartButton = ({ isLoading, onClick, testId, label, isDisabled }) => {
    const { selectedPriceTier } = useContext(PriceTiersContext);
    const hasPrice = selectedPriceTier && selectedPriceTier.quantity > 1;
    const formattedPrice = selectedPriceTier?.total_price && _jsx(FormattedPrice, { ...selectedPriceTier.total_price });
    return (_jsx("div", { className: styles.addProductButtonWrapper, children: _jsxs(Button, { isPending: isLoading, onClick: onClick, "data-testid": testId, className: styles.button, "data-event-selector": "product-details-add-product-button", disabled: isDisabled, children: [label, " ", hasPrice && _jsxs(_Fragment, { children: ["(", formattedPrice, ")"] })] }) }));
};
export default AddToCartButton;
//# sourceMappingURL=AddToCartButton.js.map